/* BlackHype (2026-10-08): comportamentos gerais do tema novo.
   1. Tira o "(+€5)" do nome da opção de personalização (o valor real, na moeda do visitante, está na etiqueta ao lado).
   2. Amarra patch e camisa no carrinho: patch sem a camisa correspondente sai; a quantidade do patch acompanha a da camisa.
   3. Traduções dos textos próprios do tema (assets/bh-i18n-<idioma>.json), aplicadas quando o idioma não é inglês. */
(function () {
  'use strict';

  /* ---------- 1. nome da opção sem o valor em euro ---------- */
  var RE_VALOR = /\s*\(\s*\+\s*[^)]*\d[^)]*\)\s*:?/;
  function limparRotulos(raiz) {
    var alvos = (raiz || document).querySelectorAll('variant-selects legend, variant-selects .form__label, .product-option dt, .cart-item__details dt');
    for (var i = 0; i < alvos.length; i++) {
      var el = alvos[i];
      if (!/custom|personal/i.test(el.textContent) || !RE_VALOR.test(el.textContent)) continue;
      for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && RE_VALOR.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(RE_VALOR, function (m) { return /:\s*$/.test(m) ? ':' : ''; });
    }
  }

  /* ---------- 2. patch e camisa no carrinho ---------- */
  var sincronizando = false;
  function raizLoja() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function sincronizarPatches() {
    if (sincronizando) return;
    sincronizando = true;
    fetch(raizLoja() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var camisas = {}, updates = {}, mudou = false;
        cart.items.forEach(function (it) { var p = it.properties || {}; if (p._patch_link && !p._jersey_key) camisas[p._patch_link] = (camisas[p._patch_link] || 0) + it.quantity; });
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          if (!p._patch_link || !p._jersey_key) return;
          var quer = camisas[p._patch_link] || 0;
          if (it.quantity !== quer) { updates[it.key] = quer; mudou = true; }
        });
        if (!mudou) return null;
        return fetch(raizLoja() + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function () { return true; });
      })
      .then(function (mudou) {
        if (!mudou) return;
        var itens = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
        if (itens && typeof itens.onCartUpdate === 'function') itens.onCartUpdate();
        else if (/\/cart(\/|$|\?)/.test(location.pathname)) location.reload();
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { sincronizando = false; }, 400); });
  }

  /* ---------- 3. traduções dos textos próprios do tema ---------- */
  var dic = null, dicMin = null;
  var AREAS = '[class^="bh-"], [class*=" bh-"], .bhmb, .bhml, .bhmc, [class^="bhm"], .md-patches, .personalizacao-fields, .header__inline-menu, .menu-drawer, .footer, .bh-hsearch, dialog.bh-sg, product-info, .related-products';
  function traduzNo(n) {
    var t = n.nodeValue; if (!t || !t.trim()) return;
    var chave = t.replace(/\s+/g, ' ').trim(); var novo = dic[chave];
    // o CSS do tema muda a caixa de vários rótulos; se não achar igual, tenta sem diferenciar maiúsculas
    if (!novo && dicMin) { var m = dicMin[chave.toLowerCase()]; if (m) novo = chave === chave.toLowerCase() ? m.toLowerCase() : m; }
    // textos que começam com um número ("3 patches available"): traduz o resto e mantém o número
    if (!novo) { var mm = chave.match(/^(\d+)\s+(.+)$/); if (mm && (dic[mm[2]] || (dicMin && dicMin[mm[2].toLowerCase()]))) novo = mm[1] + ' ' + (dic[mm[2]] || dicMin[mm[2].toLowerCase()]); }
    if (novo) n.nodeValue = t.replace(t.trim(), novo);
  }
  function traduz(raiz) {
    if (!dic || !raiz || raiz.nodeType !== 1) return;
    var areas = raiz.matches && raiz.matches(AREAS) ? [raiz] : [];
    if (raiz.closest && raiz.closest(AREAS)) areas = [raiz];
    else areas = areas.concat([].slice.call(raiz.querySelectorAll(AREAS)));
    areas.forEach(function (a) {
      var w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) { var pai = n.parentNode && n.parentNode.nodeName; if (pai === 'SCRIPT' || pai === 'STYLE') continue; traduzNo(n); }
      [].slice.call(a.querySelectorAll('[placeholder], [aria-label], [data-inicial]')).forEach(function (el) {
        ['placeholder', 'aria-label', 'data-inicial'].forEach(function (at) { var v = el.getAttribute(at); if (v && dic[v.trim()]) el.setAttribute(at, dic[v.trim()]); });
      });
    });
  }
  function iniciarTraducao() {
    var el = document.querySelector('[data-bh-i18n]'); if (!el) return;
    var url = el.getAttribute('data-bh-i18n'); if (!url) return;
    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j) return; dic = j; dicMin = {}; for (var k in j) { var kl = k.toLowerCase(); if (!(kl in dicMin)) dicMin[kl] = j[k]; } traduz(document.body);
      new MutationObserver(function (ms) { ms.forEach(function (m) { [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) traduz(n); else if (n.nodeType === 3 && n.parentNode && n.parentNode.closest && n.parentNode.closest(AREAS)) traduzNo(n); }); }); }).observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }

  function pronto() {
    limparRotulos(document);
    new MutationObserver(function () { limparRotulos(document); }).observe(document.body, { childList: true, subtree: true });
    sincronizarPatches();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sincronizarPatches, 300); });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(sincronizarPatches, 1800); }, true);
    iniciarTraducao();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pronto); else pronto();
})();
